<template>
  <div class="fangjia">
    <van-form @submit="onSubmit" ref="fangjiaForm">
      <!--所属小区-->
      <van-field input-align="right" :value="form.areaName" readonly clickable required label="所在地区"
        placeholder="点击选择所在地区" @click="showArea = true" :rules="[{ required: true, message: '选择所在地区' }]">
        <template #right-icon>
          <van-icon name="arrow" />
        </template>
      </van-field>
      <van-popup v-model="showArea" position="bottom" round>
        <van-picker show-toolbar :columns="areaColums" value-key="name" @confirm="onAreaComfirm"
          @cancel="showArea = false">
        </van-picker>
      </van-popup>

      <van-field input-align="right" v-show="form.areaId" :value="form.villageName" readonly clickable required
        label="小区名称" placeholder="点击选择小区" @click="showViallge = true" :rules="[{ required: true, message: '请选择小区' }]">
        <template #right-icon>
          <van-icon name="arrow" />
        </template>
      </van-field>
      <van-popup v-model="showViallge" position="bottom" round>
        <van-picker show-toolbar :columns="searchColumns" value-key="name" @confirm="onVillageConfirm"
          @cancel="showViallge = false">
          <template #title>
            <van-search v-model="searchKey" clearable style="    margin-top: 10px;    width: 60%;"
              placeholder="请输入小区名称搜索" />
          </template>

        </van-picker>
      </van-popup>

      <van-field input-align="right" v-model="form.detailAddress" required name="detailAddress" label="详细地址"
        placeholder="详细地址" :rules="[{ required: true, message: '请填写详细地址' }]" />

      <van-field input-align="right" :value="form.tdjb" readonly clickable required name="tdjb" label="土地级别"
        placeholder="点击选择土地级别" @click="showTdjb = true" :rules="[{ required: true, message: '选择土地级别' }]">
        <template #right-icon>
          <van-icon name="arrow" />
        </template>
      </van-field>

      <van-popup v-model="showTdjb" position="bottom" round>
        <van-picker show-toolbar :columns="tdjbColumns" @confirm="tdjbConfirm" @cancel="showTdjb = false">

        </van-picker>
      </van-popup>

      <van-field input-align="right" :value="form.fclx" readonly clickable required name="fclx" label="房产类型"
        placeholder="点击选择房产类型" @click="showFclx = true" :rules="[{ required: true, message: '选择房产类型' }]">
        <template #right-icon>
          <van-icon name="arrow" />
        </template>
      </van-field>
      <van-popup v-model="showFclx" position="bottom" round>
        <van-picker show-toolbar :columns="fclxColumns" @confirm="fclxConfirm" @cancel="showFclx = false" />
      </van-popup>
      <!-- <div v-if="form.fclx == '套房'"> -->
      <van-field v-if="form.fclx == '套房'" input-align="right" :value="form.sfdt" readonly clickable required name="sfdt"
        label="是否为电梯房" placeholder="点击选择是否为电梯房" @click="showDtf = true"
        :rules="[{ required: true, message: '选择是否为电梯房' }]">
        <template #right-icon>
          <van-icon name="arrow" />
        </template>
      </van-field>
      <van-popup v-model="showDtf" position="bottom" round>
        <van-picker show-toolbar :columns="sfdtColumns" @confirm="sfdtConfirm" @cancel="showDtf = false" />
      </van-popup>

      <van-field v-if="form.fclx == '套房'" input-align="right" :value="form.sfycw" readonly clickable required
        name="chewei" label="是否有车位" placeholder="点击选择是否有车位" @click="showCar = true"
        :rules="[{ required: true, message: '选择是否有车位' }]">
        <template #right-icon>
          <van-icon name="arrow" />
        </template>
      </van-field>
      <van-popup v-model="showCar" position="bottom" round>
        <van-picker show-toolbar :columns="cheweiColumns" @confirm="cheweiConfirm" @cancel="showCar = false" />
      </van-popup>

      <van-field v-if="form.fclx == '套房'" input-align="right" v-model="form.cwdz" type="text" required name="cwdz"
        label="车位地址" placeholder="请输入车位地址" :rules="[{ required: true, message: '请填写车位地址' }]" />

      <van-field v-if="form.fclx == '套房'" input-align="right" v-model="form.floorNumber" type="digit" required
        name="floorNumber" label="所在层数" placeholder="所在层数"
        :rules="[{ required: true, message: '请填写所在层数' },{ validator: szlcValidator, message: '请输入正确楼层' }]" />

      <van-field v-if="form.fclx == '套房'" input-align="right" v-model="form.maxFloorNumber" type="digit" required
        name="maxFloorNumber" label="楼层总数" placeholder="楼层总数"
        :rules="[{ required: true, message: '请填写楼层总数' },{ validator:zcsValidator, message: '请输入正确楼层' }]" />
      <!-- </div> -->

      <van-field input-align="right" v-model="form.jcnf" type="digit" required name="jcnf" label="建成年份"
        placeholder="建成年份"
        :rules="[{ required: true, message: '请填写建成年份' },{ validator:jcnfValidator, message: '请输入正确年份' }]" />
      <van-field input-align="right" v-model="form.cqmj" type="number" required name="cqmj" label="产权证面积"
        placeholder="产权证面积"
        :rules="[{ required: true, message: '请填写产权证面积' },{ validator:jzmjValidator, message: '请输入正确产权证面积' }]" />
      <van-field input-align="right" v-model="form.gtmj" type="number" required name="gtmj" label="公摊面积"
        placeholder="公摊面积"
        :rules="[{ required: true, message: '请填写公摊面积' },{ validator:gtmjValidator, message: '请输入正确公摊面积' }]" />
      <van-field input-align="right" v-model="form.tdmj" type="number" required name="tdmj" label="土地面积"
        placeholder="土地面积"
        :rules="[{ required: true, message: '请填写土地面积' },{ validator:tdmjValidator, message: '请输入正确土地面积' }]" />

      <div v-if="form.fclx == '栋房（整栋抵押）'">
        <van-field input-align="right" v-model="form.dmjzmj" type="number" required name="jzmj" label="店面产权证面积"
          placeholder="店面产权证面积"
          :rules="[{ required: true, message: '请填写店面产权证面积' },{ validator:dmmjValidator, message: '请输入正确店面产权证面积' }]" />
      </div>

      <van-field input-align="right" :value="form.sfxq" readonly clickable required name="xqf" label="是否为学区房"
        placeholder="点击选择是否为学区房" @click="showXqf = true" :rules="[{ required: true, message: '选择是否为学区房' }]">
        <template #right-icon>
          <van-icon name="arrow" />
        </template>
      </van-field>
      <van-popup v-model="showXqf" position="bottom" round>
        <van-picker show-toolbar :columns="xqfColumns" @confirm="xqfConfirm" @cancel="showXqf = false" />
      </van-popup>
      <!-- <van-field input-align="right" v-model="form.name" required name="name" label="姓名" placeholder="请输入姓名"
        :rules="[{ required: true, message: '请填写姓名' }]" />
      <van-field input-align="right" v-model="form.mobile" required name="mobile" label="手机号码" placeholder="请输入手机号码"
        :rules="[{ required: true, message: '请填写手机号码' }]" /> -->

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { getAreaList, getVillageList, save, getRecordById } from '@/api/public';
import { Toast } from 'vant';

export default {
  name: 'fangjia',
  data() {
    return {
      showArea: false, //所属地区pick
      showViallge: false, //所属小区pick
      showTdjb: false, //土地级别
      showFclx: false, //房产类型
      showDtf: false, //电梯房
      showCar: false, //是否有车位
      showXqf: false,
      searchColumns: [],
      form: {
        recordId: '',
        areaId: '', //地区id
        name: '', //评估人姓名
        mobile: '', //手机号码
        areaName: '', //地区名称
        villageId: '', //小区id
        villageName: '', //小区名称
        detailAddress: '', //详细地址
        tdjb: '', //土地级别
        fclx: '', //房产类型
        floorNumber: '', //所在楼层
        maxFloorNumber: '', //总楼层数
        sfdt: '', //是否电梯
        jcnf: '', //建成年份
        cqmj: '', //产权面积
        gtmj: '', //公摊面积
        tdmj: '', //土地面积
        sfxq: '', //是否学区
        sfycw: '', //是否有车位
        cwdz: '', //车位地址
        xqf: '', //学区房
        dmjzmj: '',
      },
      areaColums: [],
      villageColums: [],
      tdjbColumns: [
        //土地级别选择
        { text: '一级地', value: '1' },
        { text: '二级地', value: '2' },
        { text: '三级地', value: '2' },
        { text: '四级地', value: '2' },
        { text: '五级地', value: '2' },
      ],
      fclxColumns: [
        //房产类型选择
        { text: '套房', value: '1' },
        { text: '栋房（整栋抵押）', value: '2' },
        { text: '一层店面（主街）', value: '3' },
        { text: '一层店面（内街）', value: '4' },
        { text: '二层店面', value: '5' },
      ],
      sfdtColumns: [
        //是否电梯选择
        { text: '是', value: 'true' },
        { text: '否', value: 'false' },
      ],
      cheweiColumns: [
        //是否有车位
        { text: '是', value: 'true' },
        { text: '否', value: 'false' },
      ],
      xqfColumns: [
        //学区房
        { text: '是', value: 'true' },
        { text: '否', value: 'false' },
      ],
      searchKey: '',
    };
  },
  watch: {
    //实时监听搜索输入内容
    searchKey: function () {
      let key = String(this.searchKey);
      key = key.replace(/\s*/g, ''); //去除搜索内容中的空格
      const reg = new RegExp(key, 'ig'); //匹配规则-i：忽略大小写，g：全局匹配
      /* 进行筛选，将筛选后的数据放入新的数组中，‘name’键可根据需要搜索的key进行调整 */
      this.searchColumns = this.villageColums.filter(
        (item) => item.name.match(reg) != null
      );
    },
  },
  created() {
    debugger;
    let id = this.$route.query.id;
    if (id) {
      this.form.recordId = id;
      this.getRecord();
    }
    this.getList();
  },
  methods: {
    getList() {
      getAreaList()
        .then((res) => {
          this.areaColums = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getVillageList() {
      getVillageList(this.form.areaId)
        .then((res) => {
          this.villageColums = res.data;
          this.searchColumns = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getRecord() {
      getRecordById(this.form.recordId).then((res) => {
        this.form = res.data;
      });
    },
    onSubmit(values) {
      if (this.form.fclx != '套房') {
        this.form.sfdt = '';
        this.form.sfycw = '';
        this.form.floorNumber = '';
        this.form.maxFloorNumber = '';
      } else {
        if (Number(this.form.floorNumber) > Number(this.form.maxFloorNumber)) {
          Toast.fail('所在层数不能大于总层数');
          return false;
        }
      }
      if (this.form.fclx != '栋房（整栋抵押）') {
        this.form.dmjzmj = '';
      }
      save(this.form)
        .then((res) => {
          debugger;
          this.$router.push({
            path: '/result',
            query: res.data,
          });
        })
        .catch((e) => {
          console.log(e);
        });
      console.log('submit', values);
    },
    onAreaComfirm(value) {
      //小区选择
      debugger;
      this.form.areaName = value.name;
      this.form.areaId = value.areaId;
      this.getVillageList();
      this.showArea = false;
    },
    onVillageConfirm(value) {
      debugger;
      this.form.villageId = value.villageId;
      this.form.villageName = value.name;
      this.showViallge = false;
    },
    tdjbConfirm(value) {
      this.form.tdjb = value.text;
      this.showTdjb = false;
    },
    fclxConfirm(value) {
      this.form.fclx = value.text;
      this.showFclx = false;
    },
    sfdtConfirm(value) {
      this.form.sfdt = value.text;
      this.showDtf = false;
    },
    cheweiConfirm(value) {
      this.form.sfycw = value.text;
      this.showCar = false;
    },
    xqfConfirm(value) {
      this.form.sfxq = value.text;
      this.showXqf = false;
    },
    szlcValidator(value) {
      return Number(value) > 0;
    },
    zcsValidator(value) {
      return Number(value) > 0;
    },
    jcnfValidator(value) {
      let year = new Date().getFullYear();
      return Number(value) > 1950 && Number(value) <= year;
    },
    jzmjValidator(value) {
      return Number(value) > 0;
    },
    dmmjValidator(value) {
      return Number(value) >= 0;
    },
    gtmjValidator(value) {
      return Number(value) >= 0;
    },
    tdmjValidator(value) {
      return Number(value) >= 0;
    },
  },
};
</script>
<style lang="less">
.fangjia {
  .van-field__error-message {
    text-align: right;
  }
}
</style>
